import type { Vec2 } from "kaplay";

// Custom reticle that tracks the aim point. The system cursor is hidden by the
// game scene. getAim() returns the current aim (mouse, or a debug override).
export function addCrosshair(getAim: () => Vec2) {
  const col = rgb(255, 48, 48); // crosshair red
  const r = 13; // arm outer radius
  const gap = 5; // central gap
  const t = 2; // arm thickness
  const len = r - gap;

  const ch = add([pos(getAim()), z(1000)]);

  ch.onUpdate(() => {
    ch.pos = getAim();
  });

  // Drawn in the object's local space, so (0,0) is the aim point.
  ch.onDraw(() => {
    drawRect({ pos: vec2(-1, -1), width: 2, height: 2, color: col }); // center dot
    drawRect({ pos: vec2(-t / 2, -r), width: t, height: len, color: col }); // up
    drawRect({ pos: vec2(-t / 2, gap), width: t, height: len, color: col }); // down
    drawRect({ pos: vec2(-r, -t / 2), width: len, height: t, color: col }); // left
    drawRect({ pos: vec2(gap, -t / 2), width: len, height: t, color: col }); // right
  });

  return ch;
}
